import { selectors } from 'data'
import { select, takeEvery } from 'redux-saga/effects'
import { getTracking } from 'services/api/analytics'
import isLocal from 'utils/isLocal'

import { INIT, TRACK_EVENT, TrackEventAction } from './actions'
import analytics from './analytics'
import { utmParser } from './utils'

const trackEvent = function* (trackAction: TrackEventAction) {
  if (isLocal()) return

  const user = yield select(selectors.auth.getUser)
  const nabuId = user?.id
  const email = user?.email
  const tier = yield select(selectors.auth.getUserTiersCurrent)

  analytics.push(trackAction.payload.key, {
    properties: trackAction.payload.properties,
    traits: {
      email,
      nabuId,
      tier
    }
  })
}

const clear = function () {
  analytics.clear()
}

const init = function () {
  if (isLocal()) return

  const utm = utmParser(window.location.hash)
  sessionStorage.setItem('utm', JSON.stringify(utm))
  getTracking()
}

export default function* analyticsMain() {
  yield takeEvery(INIT, init)
  yield takeEvery(TRACK_EVENT, trackEvent)
  yield takeEvery('@@INIT', clear)
}
